module.exports = __webpack_public_path__ + "static/media/phone4.fcab5520.svg";